<template>
  <main class="container">
    <div class="row justify-content-center">
      <CategoriesList :categorias="categorias" :categoryId="categoryId" />
    </div>
    <div class="row">
      <div class="col-12">
        <ArticlesList :categorias="categorias" :categoryId="categoryId" />
        <RequestSection :telefone="telefone"/>
      </div>
    </div>
  </main>
</template>
<style lang="scss">
.main {
  width: 90%;
  max-width: 1160px;
  margin: 50px auto 0 auto;
}
</style>

<script>
import { configs } from "@/assets/data/data.json";
import RequestSection from "@/components/RequestSection";
import CategoriesList from "@/components/CategoriesList";
import ArticlesList from "@/components/ArticlesList";
export default {
  name: "Category",
  components: {
    RequestSection,
    CategoriesList,
    ArticlesList
  },
  data: function() {
    return {
      categorias: "",
      categoryId: this.$route.params.categoryId,
      telefone: ""
    };
  },
  created() {
    this.fetchData();
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    fetchData() {
      this.categoryId = this.$route.params.categoryId;
      this.categorias = configs[this.$parent.site].categorias;
      this.telefone = configs[this.$parent.site].telefone;
    }
  }
};
</script>
